import { useEffect } from "react";

const Popover = (props) => {
   const { onClose, children, isOpen } = props;

   useEffect(() => {
      const handleOutsideClick = (e) => {
         if (!e.target.closest('.popup-content-popover') && onClose) {
            onClose()
         }
      }
      document.addEventListener('mousedown', handleOutsideClick)
      return () => {
         document.removeEventListener('mousedown', handleOutsideClick)
      }
   }, []);

   return (
      <div className="popup-content popup-content-popover">
         {isOpen && children}
      </div>
   )

}

export default Popover;